import UserSettingStructure from "../Constants/UserSettingStructure";

/**
 * Fetch user settings from a mock JSON file and format it
 * @param {string} userId - The user ID used to locate the JSON file
 * @returns {Promise<Object|null>} - Returns formatted UserSettingStructure or null if failed
 */
export async function fetchUserSettings(userid) {
  try {
    // 🔹 Fetch the mock JSON file (in public/api/mock/UserSettings/)
    const response = await fetch(`/api/mock/Settings/UserSettingsMockData-${userid}.json`);

    if (!response.ok) {
      throw new Error(`❌ Failed to fetch user settings for ${userid}: ${response.status} ${response.statusText}`);
    }

    const rawData = await response.json();

    // 🔹 Format and validate the data according to UserSettingStructure
    const formattedData = {
      ...UserSettingStructure,
      userid: rawData.userId || "",
      useruuid: rawData.useruuid || "uuid-" + rawData.userId || "",
      username:
        rawData.name?.firstName && rawData.name?.lastName
          ? `${rawData.name.firstName} ${rawData.name.lastName}`
          : rawData.username || "",
      userimageurl: rawData.userimageurl || "/assets/User/default-profile.jpg",
      feedviewmode: rawData.feedviewmode || "grid",
      sortorder: rawData.sortorder || "recent",
      globaltheme: rawData.globaltheme || "shinyBlack",
      perprofiletheme: rawData.perprofiletheme ?? true,
      perprofiledisplaymode: rawData.perprofiledisplaymode ?? true,
      globaldisplaymode: rawData.globaldisplaymode || "lightbox",
      issubscribed: rawData.issubscribed ?? "true",
      currentpassword: rawData.password || "",
      mobnumber: rawData.mobileNumber || "",
      location:
        rawData.address
          ? `${rawData.address.city || ""}, ${rawData.address.state || ""}, ${rawData.address.country || ""}`.trim()
          : "",
      profiles: Array.isArray(rawData.profiles)
        ? rawData.profiles.map((profile, idx) => ({
            profileid: profile.profileid || `${profile.profilename?.slice(0, 3) || "pro"}${String(idx + 1).padStart(2, "0")}`,
            profileuuid: profile.profileuuid || `uuid-profile-${profile.profilename || "default"}-${idx + 1}`,
            profiletype: profile.profilename || "",
            profileimageurl: profile.profileimage || "",
            profiletheme: profile.profiletheme || rawData.globaltheme || "default",
            profiledisplaymode: profile.mediaDisplayMode || rawData.globaldisplaymode || "grid",
          }))
        : [],
      parentalcontrol: rawData.consent?.termsAccepted === false ? true : false,
      dateofbirth: rawData.dateOfBirth || "",
      naccountwithpc: rawData.nProfCount || 0,
      accountstatus: rawData.accountstatus || "active",
      accounttype: rawData.accounttype || "personal",
    };

    return formattedData;
  } catch (error) {
    console.error("🚨 Error fetching user settings:", error);
    return null;
  }
}
